import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Template } from '../../types/templates';

interface TemplateSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTemplateSelect: (template: Template) => void;
  templates: Template[];
  isLoading?: boolean;
}

const TemplateSelectionModal: React.FC<TemplateSelectionModalProps> = ({
  isOpen,
  onClose,
  onTemplateSelect,
  templates,
  isLoading = false,
}) => {
  // Função para obter o nome de exibição do template
  const getDisplayName = (template: Template) => {
    if (template.name.toLowerCase() === 'default') {
      return 'Modelo em Branco';
    }
    return template.name;
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex justify-between items-center mb-4">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    Selecione um Template
                  </Dialog.Title>
                  <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="mt-4">
                  {isLoading ? (
                    <div className="flex justify-center items-center h-32">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    </div>
                  ) : templates.length === 0 ? (
                    <div className="text-center py-8">
                      <p className="text-gray-500 mb-4">Nenhum modelo disponível.</p>
                      <p className="text-sm text-gray-400">Crie modelos na seção de Modelos para usá-los aqui.</p>
                    </div>
                  ) : (
                    <>
                      <div className="space-y-4 mb-6">
                  {templates.map((template) => (
                    <button
                      key={template.id}
                      onClick={() => onTemplateSelect(template)}
                            className={`w-full p-4 text-left border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                              // No longer tracking selectedTemplate, so this logic is removed.
                              // The button will always be active if templates are available.
                              'hover:bg-gray-50'
                            }`}
                    >
                            <h4 className="text-sm font-medium text-gray-900">{getDisplayName(template)}</h4>
                      <p className="mt-1 text-sm text-gray-500">{template.description}</p>
                    </button>
                  ))}
                      </div>

                      {/* Removed versioning and confirmation logic */}
                    </>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default TemplateSelectionModal; 